import { LOCAL_OR_PLAYGROUND } from '@src/utils/localOrPlayground'

interface UrlPrefixArgs {
  path: string
  playground?: boolean
  subdomain?: string
}

const easybibUrlPrefix = ({
  path,
  playground = LOCAL_OR_PLAYGROUND,
  subdomain = '',
}: UrlPrefixArgs) => {
  if (subdomain && easybibSubDomainsWithoutPlayground.includes(subdomain)) {
    playground = false
  }
  if (matchPath(easybibPathsWithoutPlayground, path)) {
    playground = false
  }
  return `//${subdomain}${subdomain.length ? '.' : ''}${
    playground ? 'playground.' : ''
  }easybib.com${path}`
}

export const matchPath = (array: string[], urlComponent: string): boolean =>
  array.reduce((matched, inList) => {
    if (matched) {
      return matched
    }
    return urlComponent.includes(inList)
  }, false)

export const easybibPathsWithoutPlayground = ['/guides']

export const easybibSubDomainsWithoutPlayground = ['titlepage', 'support']

export default easybibUrlPrefix



// WEBPACK FOOTER //
// ./src/utils/easybibUrlPrefix.ts